(function() {
  document.querySelectorAll('.js-basic-slider').forEach(slider => {
    let delay = parseInt(slider.dataset.slideDelayMs || '5000');
    if (isNaN(delay)) {
      delay = 10000;
    }

    const slides = [...slider.querySelectorAll(':scope > *')];
    let active_index = slides.findIndex(slide => slide.classList.contains('is-active'));
    if (active_index === -1) {
      active_index = 0;
      slides[0].classList.add('is-active');
    }

    setTimeout(function nextSlide() {
      slides[active_index].classList.remove('is-active');
      active_index = (active_index + 1) % slides.length;
      slides[active_index].classList.add('is-active');

      setTimeout(nextSlide, delay);
    }, delay);
  });
})();
